module.exports = {
  "country": "NO",
  "artist": "Alessandra",
  "song": "Queen of Kings",
  "year": "2023",
  "place": "5",
  "spotify": "14LdhxElpZS0rKVV4nxtdA"
};